module.exports = __webpack_public_path__ + "static/media/google-play-badge.en.db9b21a1.png";